const EcologicalCase = () => {}

export default EcologicalCase